const IconArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46967 6.96967C3.76256 6.67678 4.23744 6.67678 4.53033 6.96967L10 12.4393L15.4697 6.96967C15.7626 6.67678 16.2374 6.67678 16.5303 6.96967C16.8232 7.26256 16.8232 7.73744 16.5303 8.03033L10.5303 14.0303C10.2374 14.3232 9.76256 14.3232 9.46967 14.0303L3.46967 8.03033C3.17678 7.73744 3.17678 7.26256 3.46967 6.96967Z"
        fill="#8D9299"
      />
    </svg>
  );
};

export default IconArrow;
